import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import { v4 as uuid } from "uuid";
import {
  fetchEligibleServices,
  fetchUserOrders,
  updateAuthToken,
  fetchAnalyticsPreferencesConfig
} from "ducks/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  urlParam,
  gotoUrl,
  pathWithChannel,
  isWebView,
  isRevisit,
  isAccountTerminated,
  multiLineTelcoInfoStatus
} from "utils/helpers";
import { makeSelectPlanTextName } from "ducks/selectors";
import {
  ORDER_TYPES,
  paths,
  publicPaths,
  SIGNINTYPE,
  SIGNINTYPE_PATHS
} from "utils/constants";
import { getAndRemoveItem, APP_REDIRECT_PATH } from "utils/localStorage";
import { fetchExternalPendingOrders } from "ducks/actions/index";

const useFetchOrdersAndRedirect = redirectChannel => {
  const redirect = urlParam("redirect");
  // const urlAuthToken = urlParam("auth_token");
  const dispatch = useDispatch();

  const hasVisitedPreCheckoutPage = !!useSelector(makeSelectPlanTextName());

  const fetchOrdersAndRedirect = async (
    channel,
    redirectPath,
    userDetails,
    overrideReset
  ) => {
    const headers = { "X-REQUEST-ID": uuid() };

    dispatch(fetchAnalyticsPreferencesConfig({ "x-requestId": uuid() })); //calling Analytics settings Api

    if (redirect) {
      return gotoUrl(redirect, false, {}, false);
    }

    // const currentPath = window.location.pathname;
    // const isSignUpPath =
    //   currentPath ===
    //   pathWithChannel(
    //     publicPaths.VERIFY_OTP.replace(SIGNINTYPE, SIGNINTYPE_PATHS.SIGNUP)
    //   );

    // if (isSignUpPath) {
    const email = get(userDetails, "email", "");
    const pendingOrders = await new Promise((resolve, reject) => {
      dispatch(
        fetchExternalPendingOrders({ email }, (result, error) => {
          if (error) {
            resolve([]);
            // Don't use reject here or else it would break the functionality
          } else resolve(result);
        })
      );
    });
    if (pendingOrders?.carts?.length) {
      return gotoUrl(paths.PENDING_ORDERS, false, {}, false);
    }
    // }

    dispatch(
      fetchUserOrders({}, (userOrders, errors) => {
        const orders = userOrders;
        const reload = isWebView();
        if (errors) {
          // If errors invalidate the token and redirect to login page
          dispatch(updateAuthToken(null, null));
          return gotoUrl(
            pathWithChannel(
              publicPaths.LOGIN_PAGE.replace(
                SIGNINTYPE,
                SIGNINTYPE_PATHS.LOGIN
              ),
              channel
            )
          );
        }

        const redirectFromSocialLogin = getAndRemoveItem(APP_REDIRECT_PATH);

        if (redirectFromSocialLogin)
          return gotoUrl(redirectFromSocialLogin, false, {}, reload);

        if (!isEmpty(orders) || get(userDetails, "telco_user", false)) {
          // we are clearing the auth_token param to load manage/update-card pag
          const currentPath = window.location.pathname;
          const isLoginOrSignupPath =
            currentPath ===
            pathWithChannel(
              publicPaths.LOGIN_PAGE.replace(SIGNINTYPE, SIGNINTYPE_PATHS.LOGIN)
            );

          if (redirectPath && !isLoginOrSignupPath)
            return gotoUrl(redirectPath, true, {
              auth_token: null,
              ...(overrideReset && { reset: false })
            });

          if (redirect) return gotoUrl(redirect, false, {}, false);

          if (
            isWebView() &&
            get(userDetails, "telco_user", false) &&
            multiLineTelcoInfoStatus(get(userDetails, "telco_info"), "Active")
          ) {
            return gotoUrl(paths.DASHBOARD, false, {}, reload);
          }

          dispatch(
            fetchEligibleServices(headers, {}, (userEligibility, errors) => {
              if (isAccountTerminated(userEligibility, userDetails)) {
                return gotoUrl(paths.PRE_CHECKOUT.replace(":channel", "web"));
              } else if (!isEmpty(orders)) {
                let orderList = orders.filter(
                  order => order.order_type === ORDER_TYPES.SIM_ONLY
                );
                if (orderList?.length > 1) {
                  gotoUrl(paths.MY_ORDERS, true, {}, true);
                } else {
                  return gotoUrl(
                    paths.MANAGE_ORDER,
                    false,
                    { order_ref: get(orderList[0], "order_ref") },
                    false
                  );
                }
              } else {
                const nextRoute =
                  hasVisitedPreCheckoutPage && !isWebView()
                    ? paths.CONNECTION_DETAILS
                    : isRevisit() || !isWebView()
                    ? paths.PRE_CHECKOUT
                    : paths.CONNECTION_DETAILS;
                return gotoUrl(
                  pathWithChannel(nextRoute, redirectChannel),
                  false,
                  {},
                  reload
                );
              }
            })
          );
        } else {
          const nextRoute =
            hasVisitedPreCheckoutPage && !isWebView()
              ? paths.CONNECTION_DETAILS
              : isRevisit() || !isWebView() || !hasVisitedPreCheckoutPage
              ? paths.PRE_CHECKOUT
              : paths.CONNECTION_DETAILS;
          return gotoUrl(
            pathWithChannel(nextRoute, redirectChannel),
            false,
            {},
            reload
          );
        }

        //if user is logging in webview without auth_token in url, then user redirect to weblogin
        // if (isWebView() && !urlAuthToken && isTelcoUser && !isAUAccount()) {
        //   return gotoUrl(paths.DASHBOARD, false, {}, reload);
        // }

        // if (!isEmpty(orders)) {
        //   return gotoUrl(
        //     `${paths.MANAGE_ORDER}?order_ref=${orders[0].order_ref}`,
        //     false,
        //     {},
        //     reload
        //   );
        // }
      })
    );
  };

  return fetchOrdersAndRedirect;
};

export default useFetchOrdersAndRedirect;
